import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    enableLogs: true,
    integrations: [Sentry.consoleLoggingIntegration({ levels: ['info', 'warn', 'error'] })],
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}
